import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-chat-input',
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChatInputComponent {
  @Input() disabled = false;
  @Output() send = new EventEmitter<string>();

  prompt = new FormControl('', { nonNullable: true, validators: [Validators.required] });

  submit(textarea?: HTMLTextAreaElement) {
    const value = this.prompt.value.trim();
    if (!value || this.disabled) {
      return;
    }
    this.send.emit(value);
    this.prompt.reset('');
    if (textarea) {
      this.resetTextareaHeight(textarea);
    }
  }

  handleEnter(event: KeyboardEvent, textarea: HTMLTextAreaElement) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.submit(textarea);
    }
  }

  autoResize(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  private resetTextareaHeight(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto';
  }
}
